export default {
  route: {
    upData: '上传影像',
    studyList: '检查列表',
    aiAnalysis: 'AI分析',
    peoples: '用户管理',
    muList: '医联体列表',
    hospitalList: '医院列表',
    userList: '医生列表',
    role: '权限管理',
    cloudAcc: '云端账号',
    muAcc: '医联体账号',
    hospitalAcc: '医院账号',
    myShift: '我的排班',
    statistics: '统计分析',
    editReport: '编写报告统计',
    checkReport: '审核报告统计',
    personalCenter: '个人中心',
    doctorList: '在线医生',
    downList: '下载列表',
    queryList: '跨组检索',
    shiftDoctors: '排班医生'
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    github: '项目地址',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  common: {
    Male: '男',
    Female: '女',
    unknown: '未知',
    pleaseChoose: '请选择',
    pleaseEnter: '请输入',
    Isfast: {
      ordinary: '普通',
      hospitalized: '住院',
      emergency: '急诊',
      greenChannel: '绿色通道',
      examination: '体检'
    }
  },
  upData: {
    uploadFile: '上传附件',
    uploadImage: '上传图片',
    clickToUpload: '点击上传',
    uploadNotice1: '请上传DICOM影像文件夹(.zip或者.tar格式)压缩包',
    uploadNotice2: '请上传jpg或png格式图片',
    imageInformation: '影像信息',
    applyformurl: '上传检查申请单',
    medicalhistory: '简要病史',
    diagnosishistory: '申请原因',
    patientname: '姓名',
    sex: '性别',
    age: '年龄',
    birthday: '出生日期',
    studyid: '检索编号',
    accessionnumber: '检查编号',
    patientid: '病历号',
    Isfast: '就诊类型',
    studydate: '检查日期',
    studytimes: '检查时间',
    modality: '影像类型',
    studyparts: '检查部位',
    upHospital: '上传机构',
    save: '保存',
    upload: '上传',
    message: {
      uploadSuccess: '上传成功',
      imagePlease: '请上传图片',
      successfullySaved: '保存成功',
      uploadFile: '请上传文件',
      noCommonFile: '不能上传相同文件',
      fileExists: '文件已存在'
    }
  },
  studyList: {
    // queryform
    meargewhere: '检索',
    mainkeys: '姓名/病历号/检查编号',
    starttime: '开始时间',
    endtime: '结束时间',
    ispay: '远程付费',
    likecontent: '查询内容',
    store: '收藏',
    // queryType
    thisHospital: '本地',
    remotely: '远程',
    mine: '我的',
    all: '全部',
    notReported: '未报告',
    toBePublished: '待发布',
    notReviewed: '未审核',
    audited: '已审核',
    // table
    hospitalname: '上传医院',
    totalcount: '图像数',
    patientid: '病历号',
    studyid: '检查编号',
    patientname: '姓名',
    age: '年龄',
    modality: '设备',
    studyparts: '部位',
    studystate: '类型',
    servicetime: '服务时限',
    states: '状态',
    reportdocname: '报告医生',
    checkdocname: '审核医生',
    applydatetime: '申请时间',
    studydate: '检查时间',
    uploadtime: '上传时间',
    reportresult: '报告结论',
    reporttype: 'AI分析',
    opreation: '操作',
    btn: {
      report: '报告',
      reading: '阅片',
      apply: '申请远程',
      reapply: '撤回申请'
    }
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 Tab 组件或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  components: {
    documentation: '文档',
    tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
    dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
    stickyTips: '当页面滚动到预设的位置会吸附在顶部',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  table: {
    query: '搜索',
    export: '导出',
    actions: '操作',
    cancel: '取 消',
    confirm: '确 定',
    collapse: '收起',
    expand: '高级查询'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  pdf: {
    tips: '这里使用   window.print() 来实现下载pdf的功能'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  }
};